// extracted by mini-css-extract-plugin
export default {"email":"rTPnJLwCUOehC_7arOZ_"};